module.exports = __webpack_public_path__ + "static/assets/f100495ddf7c5d4d216ea68f52a8214e.svg";